import script from "./DomainActions.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainActions.vue?vue&type=script&setup=true&lang=js"

import "./DomainActions.vue?vue&type=style&index=0&id=84493810&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84493810"]])

export default __exports__